import React, { useState } from 'react';
import styled from '@emotion/styled';
import { MinusIcon, SmallPlusIcon } from '../../components/icons';
import { IndividualSearch, InvoiceInfo } from './types';

const Wrapper = styled.div`
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  padding: 24px;
`;

const Info = styled.div`
  display: grid;
  grid-template-columns: 60% 10% 10% 10% 10%;
  grid-column-gap: 1%;
  padding: 16px 24px;
  border-top: 1px solid #e5e5ea;
`;
const SeeMore = styled.div`
 
  color: #8e8e93;
`;
const SeeMoreInner = styled.div`
  background-color: #fcfcfd;
  border-top: 1px solid #e5e5ea;
  color: #8e8e93;
  padding: 8px 80px;
  position: relative;
`;
interface Props {
  invoiceDetails: IndividualSearch;
}
const InvoiceDetails = (props: Props) => {
  const [collapseOpen, setCollapseOpen] = useState(false);

  return ( 
    <>    
        <Info>
          <div>{props.invoiceDetails?.feeType}</div>
          <div>{props.invoiceDetails?.quantity}</div>
          <div>${props.invoiceDetails?.price}</div>
          <div>{`${props.invoiceDetails?.townFee ? '$'+ props.invoiceDetails?.townFee : '-'}`}</div>
          <div>${props.invoiceDetails?.price + props.invoiceDetails?.townFee}</div>
        </Info>
        {props.invoiceDetails.feeType === 'Municipal Searches:Municipal Package' && (
          <SeeMore onClick={() => setCollapseOpen(!collapseOpen)} style={{ cursor: 'pointer', borderTop: collapseOpen ? '1px solid #fcfcfd' :   '1px solid #e5e5ea', backgroundColor: !collapseOpen ? '#fcfcfd' :  '#fff'}}>
            <div style={{ display: 'flex', alignItems: 'center', paddingBottom: 8, padding: collapseOpen ? '0' : '10px 24px' }}>
              {!collapseOpen && (
                <>
                  <SmallPlusIcon style={{ marginRight: 30 }} />
                  <span>See More</span>
                </>
              )}
            </div>
            {collapseOpen && (
              <SeeMoreInner>
                <MinusIcon style={{position:'absolute', top:16, left:24}}/>
                {props.invoiceDetails.searches.map(s => {
                  return (
                    <>
                      <div style={{ paddingTop: 8 }}>{s.searchType}</div>
                    </>
                  );
                })}
              </SeeMoreInner>
            )}
          </SeeMore>
        )}
        </>
  );
};

export default InvoiceDetails;
